// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"93e5408a","918":"224ebdf5"}[chunkId] + ".chunk.js";
};